import LBox from "@components/LBox";
import LIcon from "@components/LIcon";
import LPressable from "@components/LPressable";
import LText from "@components/LText";

const GEM_PURPLE = "#C084FC";
const GEM_BACKGROUND = "rgba(126, 87, 194, 0.35)";

// Data-sharing consent row shown on locked exclusive songs, mirroring the LIB
// access sheet. The unlock CTA is disabled while unchecked and the final state
// is persisted with the order.
const DataSharingConsent = ({
  checked,
  onChange,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
}) => {
  return (
    <LPressable
      accessibilityRole="checkbox"
      accessibilityState={{ checked }}
      onPress={() => onChange(!checked)}
      sentryEventName="AccessDetail.DataSharingConsent"
    >
      <LBox alignItems="flex-start" flexDirection="row" gap="s2">
        <LBox
          alignItems="center"
          borderRadius="s"
          borderWidth={1.5}
          height={18}
          justifyContent="center"
          mt="s0_5"
          width={18}
          style={{
            borderColor: checked ? GEM_PURPLE : "rgba(255, 255, 255, 0.5)",
            backgroundColor: checked ? GEM_BACKGROUND : "transparent",
          }}
        >
          {checked ? (
            <LIcon
              colors={{ color: GEM_PURPLE }}
              name="checkmark_curved"
              size={12}
            />
          ) : null}
        </LBox>
        <LText
          color="whiteTranslucent80"
          flexShrink={1}
          variant="Body/B2/Medium"
        >
          I accept to share my information with the artist to unlock this
          exclusive
        </LText>
      </LBox>
    </LPressable>
  );
};

export default DataSharingConsent;
